

(function () {
  'use strict';

  function ensureState(card) {
    if (card.__cerusState) return card.__cerusState;
    var jsonEl = card.querySelector('[data-cerus-pcard-data]');
    if (!jsonEl) return null;
    var data;
    try { data = JSON.parse(jsonEl.textContent); } catch (e) { return null; }

    var lockMode = card.dataset.lockMode || null;
    var initialMode = lockMode || (card.dataset.hasSub === 'true' ? 'subscription' : 'onetime');

    var state = {
      data: data,
      variantId: parseInt(card.dataset.defaultVariantId, 10),
      mode: initialMode,
      pillIdx: parseInt(card.dataset.pillOptionIndex, 10),
      lock: lockMode,
      sellingPlanId: null
    };

    var freqSelectInitial = card.querySelector('[data-cerus-pcard-freq-select]');
    if (freqSelectInitial && freqSelectInitial.value) {
      state.sellingPlanId = parseInt(freqSelectInitial.value, 10);
    }

    card.__cerusState = state;
    return state;
  }

  function currentVariant(state) {
    var d = state.data;
    for (var i = 0; i < d.variants.length; i++) {
      if (d.variants[i].id === state.variantId) return d.variants[i];
    }
    return null;
  }

  function variantForPill(state, value) {
    var current = currentVariant(state);
    var bestFallback = null;
    var variants = state.data.variants;
    for (var i = 0; i < variants.length; i++) {
      var v = variants[i];
      if (v.options[state.pillIdx] !== value) continue;
      if (current) {
        var matchesOthers = true;
        for (var j = 0; j < v.options.length; j++) {
          if (j === state.pillIdx) continue;
          if (v.options[j] !== current.options[j]) { matchesOthers = false; break; }
        }
        if (matchesOthers && v.available) return v;
      }
      if (v.available && !bestFallback) bestFallback = v;
    }
    return bestFallback;
  }

  function activeSubPrice(state, variant) {
    if (!variant || !variant.sellingPlanAllocations || !variant.sellingPlanAllocations.length) return null;
    if (state.sellingPlanId) {
      for (var i = 0; i < variant.sellingPlanAllocations.length; i++) {
        if (String(variant.sellingPlanAllocations[i].sellingPlanId) === String(state.sellingPlanId)) {
          return variant.sellingPlanAllocations[i];
        }
      }
    }
    return variant.sellingPlanAllocations[0];
  }

  function render(card) {
    var state = ensureState(card);
    if (!state) return;
    var variant = currentVariant(state);
    if (!variant) return;

    var priceEl = card.querySelector('[data-cerus-pcard-price]');
    var compareEl = card.querySelector('[data-cerus-pcard-compare]');
    var atc = card.querySelector('[data-cerus-pcard-atc]');
    var atcLabel = card.querySelector('[data-cerus-pcard-atc-label]');
    var image = card.querySelector('[data-cerus-pcard-image]');
    var saveBadge = card.querySelector('[data-cerus-pcard-save-badge]');

    var priceText = variant.priceText;
    var compareText = variant.compareText;
    var rawPrice = variant.price;
    var rawCompare = variant.compareAt;

    if (state.mode === 'subscription') {
      var alloc = activeSubPrice(state, variant);
      if (alloc) {
        priceText = alloc.priceText;
        rawPrice = alloc.price;
        if (variant.price > alloc.price) {
          compareText = variant.priceText;
          rawCompare = variant.price;
        }
      }
    }

    if (priceEl) priceEl.textContent = priceText;
    if (compareEl) {
      if (rawCompare && rawCompare > rawPrice) {
        compareEl.textContent = compareText;
        compareEl.hidden = false;
      } else {
        compareEl.hidden = true;
      }
    }

    if (image && variant.featuredImage) {
      image.src = variant.featuredImage;
      image.removeAttribute('srcset');
    }

    if (atc) {
      atc.disabled = !variant.available;
      if (atcLabel) atcLabel.textContent = variant.available ? 'Add to cart' : 'Sold out';
    }

    if (saveBadge) {
      if (rawCompare > rawPrice && rawCompare > 0) {
        var pct = Math.round(((rawCompare - rawPrice) / rawCompare) * 100);
        saveBadge.textContent = 'SAVE ' + pct + '%';
        saveBadge.hidden = false;
      } else {
        saveBadge.hidden = true;
      }
    }

    var pills = card.querySelectorAll('[data-cerus-pcard-pill]');
    var activeColor = null;
    pills.forEach(function (p) {
      var isActive = variant.options[state.pillIdx] === p.dataset.value;
      p.classList.toggle('is-active', isActive);
      if (isActive && p.dataset.color) activeColor = p.dataset.color;
    });
    if (activeColor) {
      card.style.setProperty('--cerus-pcard-accent', activeColor);
      card.style.setProperty('--cerus-pill-accent', activeColor);
    }
  }

  function addToCart(card, variant) {
    var state = ensureState(card);
    var atc = card.querySelector('[data-cerus-pcard-atc]');
    if (!atc) return;
    atc.classList.add('is-loading');
    atc.disabled = true;

    var body = { id: variant.id, quantity: 1 };
    if (state.mode === 'subscription') {
      var alloc = activeSubPrice(state, variant);
      if (alloc && alloc.sellingPlanId) body.selling_plan = alloc.sellingPlanId;
    }

    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify(body)
    })
      .then(function (res) {
        if (!res.ok) return res.json().then(function (err) { throw err; });
        return res.json();
      })
      .then(function (item) {
        return fetch('/cart.js', { headers: { 'Accept': 'application/json' } })
          .then(function (r) { return r.json(); })
          .then(function (cart) {
            document.dispatchEvent(new CustomEvent('cart:updated', { detail: { cart: cart, itemCount: cart.item_count } }));
            document.dispatchEvent(new CustomEvent('cart:added', { detail: { item: item, cart: cart } }));
            if (window.Rebuy && window.Rebuy.SmartCart && typeof window.Rebuy.SmartCart.show === 'function') {
              window.Rebuy.SmartCart.show();
            } else if (window.rebuy_cart && typeof window.rebuy_cart.show === 'function') {
              window.rebuy_cart.show();
            }
          });
      })
      .catch(function (err) {
        console.warn('[Cerus] add to cart failed', err);
        window.location.href = '/cart';
      })
      .finally(function () {
        atc.classList.remove('is-loading');
        atc.disabled = false;
      });
  }


  function renderAll(root) {
    var scope = (root && root.querySelectorAll) ? root : document;
    scope.querySelectorAll('[data-cerus-pcard]').forEach(render);
  }



  document.addEventListener('click', function (e) {
    var card = e.target.closest('[data-cerus-pcard]');
    if (!card) return;
    var state = ensureState(card);
    if (!state) return;

    var pill = e.target.closest('[data-cerus-pcard-pill]');
    if (pill && card.contains(pill)) {
      if (pill.disabled) return;
      var match = variantForPill(state, pill.dataset.value);
      if (match) { state.variantId = match.id; render(card); }
      return;
    }

    var modeBtn = e.target.closest('[data-cerus-pcard-mode]');
    if (modeBtn && card.contains(modeBtn) && !state.lock) {
      state.mode = modeBtn.dataset.cerusPcardMode;
      card.querySelectorAll('[data-cerus-pcard-mode]').forEach(function (b) {
        b.classList.toggle('is-active', b === modeBtn);
      });
      var freqEl = card.querySelector('[data-cerus-pcard-freq]');
      if (freqEl) freqEl.hidden = state.mode !== 'subscription';
      render(card);
      return;
    }

    var atcBtn = e.target.closest('[data-cerus-pcard-atc]');
    if (atcBtn && card.contains(atcBtn)) {
      var variant = currentVariant(state);
      if (!variant || !variant.available) return;
      addToCart(card, variant);
    }
  }, true);

  document.addEventListener('change', function (e) {
    var sel = e.target.closest('[data-cerus-pcard-freq-select]');
    if (!sel) return;
    var card = sel.closest('[data-cerus-pcard]');
    if (!card) return;
    var state = ensureState(card);
    if (!state) return;
    state.sellingPlanId = parseInt(sel.value, 10) || null;
    render(card);
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { renderAll(); });
  } else {
    renderAll();
  }



  document.addEventListener('shopify:section:load', function (e) { renderAll(e.target); });



  if (document.readyState === 'complete') {
    setTimeout(renderAll, 1000);
  } else {
    window.addEventListener('load', function () { setTimeout(renderAll, 1000); });
  }
})();
